export enum ValuesVariaveis {
	PRECIPITACAO = 'precipitacao',
	PRESSAO = 'pressao',

	TEMPERATURA_AR = 'temperatura',
	TEMPERATURA_SOLO = 'temperaturaSolo',
	UMIDADE = 'umidade',
}

export enum Unidade {
	PRECIPITACAO = 'mm',
	UMIDADE = '%',
	PRESSAO = 'hPa',
	TEMPERATURA_AR = 'ºC',
	TEMPERATURA_SOLO = 'ºC',
}

export enum UnidadeNdc {
	PRECIPITACAO = 'mm',
	DIAS_CHUVA = 'dias',
}

export const getUnidade = (variavel: ValuesVariaveis): string => {
	switch (variavel) {
		case ValuesVariaveis.PRECIPITACAO:
			return Unidade.PRECIPITACAO;
		case ValuesVariaveis.UMIDADE:
			return Unidade.UMIDADE;
		case ValuesVariaveis.PRESSAO:
			return Unidade.PRESSAO;
		case ValuesVariaveis.TEMPERATURA_AR:
		case ValuesVariaveis.TEMPERATURA_SOLO:
			return Unidade.TEMPERATURA_AR;
		default:
			return '';
	}
};

export const getFormattedVariavel = (variavel: ValuesVariaveis): string => {
	switch (variavel) {
		case ValuesVariaveis.PRECIPITACAO:
			return 'Precipitação';
		case ValuesVariaveis.UMIDADE:
			return 'Umidade';
		case ValuesVariaveis.PRESSAO:
			return 'Pressão atmosférica';
		case ValuesVariaveis.TEMPERATURA_AR:
			return 'Temperatura do ar';
		case ValuesVariaveis.TEMPERATURA_SOLO:
			return 'Temperatura do solo';
		default:
			return '';
	}
};

export const getLabelVariavel = (
	variavel: ValuesVariaveis | string
): string => {
	switch (variavel) {
		case ValuesVariaveis.PRECIPITACAO:
			return 'Precipitação (mm)';
		case ValuesVariaveis.UMIDADE:
			return 'Umidade do ar (%)';
		case ValuesVariaveis.PRESSAO:
			return 'Pressão atmosférica (hPa)';
		case ValuesVariaveis.TEMPERATURA_AR:
			return 'Temperatura do ar (ºC)';
		case ValuesVariaveis.TEMPERATURA_SOLO:
			return 'Temperatura do solo (ºC)';
		default:
			return '';
	}
};

const labelCardMap: { [key in ValuesVariaveis]: string } = {
	[ValuesVariaveis.PRECIPITACAO]: 'Precipitação (mm)',
	[ValuesVariaveis.UMIDADE]: 'Umidade do ar (%)',
	[ValuesVariaveis.PRESSAO]: 'Pressão atmosférica (hPa)',
	[ValuesVariaveis.TEMPERATURA_AR]: 'Temperatura do ar (ºC)',
	[ValuesVariaveis.TEMPERATURA_SOLO]: 'Temperatura do solo (ºC)',
};

export const getLabelCard = (variavel: ValuesVariaveis | string): string => {
	return labelCardMap[variavel as ValuesVariaveis] || '';
};

export enum JanelaTempo {
	'Últimas 6 horas' = '6',
	'Últimas 24 horas' = '24',
	'Últimas 48 horas' = '48',
	'Últimas 72 horas' = '72',
	'Personalizada' = 'Personalizada',
}

export enum VariavelAcompanhamentoColeta {
	TEMPERATURA_DO_AR = 'Temperatura do ar',
	UMIDADE_DO_AR = 'Umidade do ar',
	PRESSAO_ATMOSFERICA = 'Pressão atmosférica',
	RADIACAO_SOLAR = 'Radiação solar',
	PRECIPITACAO_DO_PERIODO = 'Precipitação do período',
	VENTO_VELOCIDADE_1 = 'Vento velocidade a 2 metros',
	VENTO_DIRECAO_1 = 'Vento direção a 2 metros',
	VENTO_VELOCIDADE_2 = 'Vento velocidade a 10 metros',
	VENTO_DIRECAO_2 = 'Vento direção a 10 metros',
	TEMPERATURA_DO_SOLO_10CM = 'Temperatura do solo a 10 cm',
	TEMPERATURA_DO_SOLO_20CM = 'Temperatura do solo a 20 cm',
	TEMPERATURA_DO_SOLO_30CM = 'Temperatura do solo a 30 cm',
	TEMPERATURA_DO_SOLO_40CM = 'Temperatura do solo a 40 cm',
	TEMPERATURA_DO_SOLO_50CM = 'Temperatura do solo a 50 cm',
	TEMPERATURA_DO_SOLO_60CM = 'Temperatura do solo a 60 cm',
	CONTEUDO_AGUA_SOLO_10CM = 'Conteúdo de água no solo 10cm',
	CONTEUDO_AGUA_SOLO_20CM = 'Conteúdo de água no solo 20cm',
	CONTEUDO_AGUA_SOLO_30CM = 'Conteúdo de água no solo 30cm',
	CONTEUDO_AGUA_SOLO_40CM = 'Conteúdo de água no solo 40cm',
	CONTEUDO_AGUA_SOLO_50CM = 'Conteúdo de água no solo 50cm',
	CONTEUDO_AGUA_SOLO_60CM = 'Conteúdo de água no solo 60cm',
	EVAPOTRANSPIRACAO = 'Evapotranspiração',
	VENTO_DIRECAO_1_DESVIO_PADRAO = 'Vento direção a 2 metros desvio padrão',
	VENTO_VELOCIDADE_1_MAXIMA = 'Vento velocidade a 2 metros máxima',
	VENTO_DIRECAO_2_DESVIO_PADRAO = 'Vento direção a 10 metros desvio padrão',
	VENTO_VELOCIDADE_2_MAXIMA = 'Vento velocidade a 10 metros máxima',
	VENTO_DIRECAO_1_NA_MAXIMA = 'Vento direção a 2 metros na máxima',
	VENTO_DIRECAO_2_NA_MAXIMA = 'Vento direção a 10 metros na máxima',
  TEMPERATURA_MAXIMA="Temperatura máxima",
  TEMPERATURA_MINIMA="Temperatura mínima",
  UMIDADE_MAXIMA="Umidade máxima",
  UMIDADE_MINIMA="Umidade mínima"
}

export function getUnidadeVariavelAcompanhamentoColeta(
	variavel: keyof typeof VariavelAcompanhamentoColeta,
	incluirParenteses = true
) {
	let retorno: string;
	switch (VariavelAcompanhamentoColeta[variavel]) {
		case VariavelAcompanhamentoColeta.PRECIPITACAO_DO_PERIODO:
		case VariavelAcompanhamentoColeta.EVAPOTRANSPIRACAO:
			retorno = 'mm';
			break;
		case VariavelAcompanhamentoColeta.UMIDADE_DO_AR:
    case VariavelAcompanhamentoColeta.UMIDADE_MINIMA:
    case VariavelAcompanhamentoColeta.UMIDADE_MAXIMA:
		case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_10CM:
		case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_20CM:
		case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_30CM:
		case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_40CM:
		case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_50CM:
		case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_60CM:
			retorno = '%';
			break;
		case VariavelAcompanhamentoColeta.PRESSAO_ATMOSFERICA:
			retorno = 'hPa';
			break;
    case VariavelAcompanhamentoColeta.TEMPERATURA_DO_AR:
    case VariavelAcompanhamentoColeta.TEMPERATURA_MAXIMA:
    case VariavelAcompanhamentoColeta.TEMPERATURA_MINIMA:
		case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_10CM:
		case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_20CM:
		case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_30CM:
		case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_40CM:
		case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_50CM:
    case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_60CM:
			retorno = 'ºC';
			break;
		case VariavelAcompanhamentoColeta.RADIACAO_SOLAR:
			retorno = 'W/m²';
			break;
		case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_1:
		case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_2_MAXIMA:
		case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_2:
		case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_1_MAXIMA:
			retorno = 'm/s';
			break;
		case VariavelAcompanhamentoColeta.VENTO_DIRECAO_1:
		case VariavelAcompanhamentoColeta.VENTO_DIRECAO_1_NA_MAXIMA:
		case VariavelAcompanhamentoColeta.VENTO_DIRECAO_2_DESVIO_PADRAO:
		case VariavelAcompanhamentoColeta.VENTO_DIRECAO_2:
		case VariavelAcompanhamentoColeta.VENTO_DIRECAO_1_DESVIO_PADRAO:
			retorno = '°';
			break;
		default:
			return '';
	}
	return incluirParenteses ? `(${retorno})` : retorno;
}
